import { z } from 'zod'

export const ADMINAGENTSPOSTMAPPING_CONTRACT_VERSION = '1.0.0' as const
export const adminAgentsPostMappingResponseSchema = z.unknown()
export type AdminAgentsPostMappingResponse = z.infer<typeof adminAgentsPostMappingResponseSchema>
